import { normalizeStringForComparison } from './normalizeStringForComparison';

export function stringIncludesQuery(candidate: string, query: string): boolean {
  return normalizeStringForComparison(candidate).includes(
    normalizeStringForComparison(query)
  );
}
